import { useTranslation } from 'react-i18next';
import PageShell from '@/components/feature/PageShell';

export default function SafetyPage() {
  const { t } = useTranslation('pages');

  const checks = ['safety_check_1', 'safety_check_2', 'safety_check_3', 'safety_check_4', 'safety_check_5'];

  return (
    <PageShell
      eyebrow={t('safety_eyebrow')}
      title={t('safety_h1')}
      intro={t('safety_intro')}
    >
      <div className="space-y-10">
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('safety_s1_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">{t('safety_s1_body')}</p>
        </section>
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('safety_s2_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">{t('safety_s2_body')}</p>
        </section>
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('safety_s3_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">{t('safety_s3_body')}</p>
        </section>

        <section className="bg-background-100 rounded-xl p-6 border border-background-200/40">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
            <i className="ri-shield-check-line text-primary-600"></i>
            {t('safety_checklist_title')}
          </h3>
          <ul className="space-y-2.5">
            {checks.map((c) => (
              <li key={c} className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                {t(c)}
              </li>
            ))}
          </ul>
        </section>

        <p className="text-foreground-400 text-xs italic border-l-2 border-accent-300 pl-4 py-1">
          {t('safety_disclaimer')}
        </p>
      </div>
    </PageShell>
  );
}